// extracted by mini-css-extract-plugin
export default {"cls1":"iYYt4_11cZhTfp_ztGMj","cls2":"LLd3rN6iY_1u6v9Qz8ps iYYt4_11cZhTfp_ztGMj","isPhone":"BbYcAOAID9ZgJeB61_yC"};